module.exports = __webpack_public_path__ + "img/simplecoin-big-1.49210bec.jpg";